"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ListingServiceContext_1 = require("../service/ListingServiceContext");
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var SyncSupplier_1 = require("@twii/core/lib/model/SyncSupplier");
var Sync_1 = require("@twii/core/lib/model/Sync");
var ListingStoreFrontModel = /** @class */ (function (_super) {
    __extends(ListingStoreFrontModel, _super);
    function ListingStoreFrontModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchSync = new Sync_1.Sync();
        _this.searchResults = [];
        _this._searchDelay = 500;
        _this._onSearchDone = function (results) {
            delete _this._searchTimeout;
            _this.searchResults = [];
            if (results) {
                results.forEach(function (r) {
                    _this.searchResults.push(r);
                });
            }
            _this.searchSync.syncEnd();
        };
        _this._onSearchError = function (error) {
            _this.searchResults = [];
            _this.searchSync.syncError(error);
        };
        _this._searchImpl = function () {
            var search = _this.searchText;
            if (StringUtils_1.isNotBlank(search)) {
                return ListingServiceContext_1.ListingServiceContext.value.searchListings({
                    search: search
                }).then(function (results) {
                    if (search === _this.searchText) {
                        _this._onSearchDone(results);
                    }
                }).catch(function (error) {
                    if (search === _this.searchText) {
                        _this._onSearchError(error);
                    }
                });
            }
            _this.sync.syncEnd();
            return Promise.resolve();
        };
        _this._refreshDone = function (data) {
            _this.setValue(data);
            _this.sync.syncEnd();
        };
        _this._refreshError = function (error) {
            _this.clearValue();
            _this.sync.syncError(error);
        };
        return _this;
    }
    ListingStoreFrontModel.prototype.setSearchText = function (searchText) {
        if (searchText !== this.searchText) {
            this.searchText = searchText;
            if (this._searchTimeout) {
                clearTimeout(this._searchTimeout);
            }
            if (StringUtils_1.isNotBlank(searchText)) {
                this.searchSync.syncStart({ type: "search" });
                this._searchTimeout = setTimeout(this._searchImpl, this._searchDelay);
            }
            else {
                this.searchSync.syncEnd();
            }
        }
    };
    ListingStoreFrontModel.prototype.refresh = function () {
        var ps = [];
        this.sync.syncStart();
        ps.push(ListingServiceContext_1.ListingServiceContext.value.getStoreFront().then(this._refreshDone).catch(this._refreshError));
        if (StringUtils_1.isNotBlank(this.searchText)) {
            this.sync.syncStart({ type: "search" });
            ps.push(this._searchImpl());
        }
        return Promise.all(ps);
    };
    __decorate([
        mobx_1.observable
    ], ListingStoreFrontModel.prototype, "searchSync", void 0);
    __decorate([
        mobx_1.observable
    ], ListingStoreFrontModel.prototype, "searchText", void 0);
    __decorate([
        mobx_1.observable
    ], ListingStoreFrontModel.prototype, "searchResults", void 0);
    __decorate([
        mobx_1.action
    ], ListingStoreFrontModel.prototype, "_onSearchDone", void 0);
    __decorate([
        mobx_1.action
    ], ListingStoreFrontModel.prototype, "_onSearchError", void 0);
    __decorate([
        mobx_1.action
    ], ListingStoreFrontModel.prototype, "setSearchText", null);
    __decorate([
        mobx_1.action
    ], ListingStoreFrontModel.prototype, "_refreshDone", void 0);
    __decorate([
        mobx_1.action
    ], ListingStoreFrontModel.prototype, "_refreshError", void 0);
    __decorate([
        mobx_1.action
    ], ListingStoreFrontModel.prototype, "refresh", null);
    return ListingStoreFrontModel;
}(SyncSupplier_1.SyncSupplier));
exports.ListingStoreFrontModel = ListingStoreFrontModel;
